import {
  RelationDto,
  VehicleSummonDto,
} from "@1games-ru/region-shared/dist/types/vehicle/vehicle-b";
import { useQuery } from "@tanstack/react-query";
import VehicleCdn from "@/core/cdn/vehicle/vehicle-cdn";
import VehicleMpProvider from "@/core/data-provider/data-mp/vehicle/vehicle-mp-provider";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response";
import { VehicleAccessType } from "@/domains/vehicleSpawn/types";

export const QUERY_KEY_GARAGE_VEHICLES = "garage-vehicles";

function getAccessTypeFromRelation(relation: RelationDto): VehicleAccessType | null {
  if (relation.isOwner) return VehicleAccessType.Personal;
  if (relation.isShared) return VehicleAccessType.Shared;
  return null;
}

function mapVehicle(vehicle: VehicleSummonDto) {
  return {
    vehicleId: vehicle.vehicleId,
    name: `${vehicle.name.brandName} ${vehicle.name.modelName}`,
    image: VehicleCdn.getVehicleImage(vehicle.model.toLowerCase()),
    plateNumber: vehicle.plateNumber,
    fuelType: vehicle.fuel.type,
    accessType: getAccessTypeFromRelation(vehicle.relation),
  };
}

export function useGarageVehiclesQuery({ estateComplexId }: { estateComplexId: number | null }) {
  return useQuery({
    queryKey: [QUERY_KEY_GARAGE_VEHICLES, estateComplexId],
    enabled: estateComplexId !== null,
    queryFn: async () => {
      const response = await VehicleMpProvider.getVehiclesComplexRequest({
        estateComplexId,
      });

      if (response instanceof RpcMpProviderFailedResponse) {
        throw response.error;
      }

      return response.data.map(mapVehicle);
    },
  });
}
